import { Input } from "reactstrap";
import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";

export interface FormSettingsProps {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
}

const PostSubmit = ({ form, setForm }: FormSettingsProps) => {
  const handleSetForm = (value: any, key: string) => {
    setForm({ ...form.PostSubmit, [key]: value }, "PostSubmit");
  };

  return (
    <div className="text-sm font-weight-500 text-dark">
      <label className="mb-0 mt-3">Thank You Message</label>
      <br />
      <p className="mb-0 text-medium" style={{ fontSize: 13 }}>
        The message after successful form submission
      </p>
      <Input
        type="textarea"
        value={form.PostSubmit?.ThankYouMessage}
        bsSize="sm"
        onChange={(e) => handleSetForm(e.target.value, "ThankYouMessage")}
        className="my-2"
      />

      <label className="mt-3 mb-0">URL Redirect</label>
      <br />
      <p className="mb-0 text-medium" style={{ fontSize: 13 }}>
        Where to redirect to after successful submission
      </p>
      <Input
        value={form.PostSubmit?.URLRedirect || ""}
        bsSize="sm"
        onChange={(e) => handleSetForm(e.target.value, "URLRedirect")}
        className="my-2"
        placeholder="https://"
      />
    </div>
  );
};

export default PostSubmit;
